import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HeadProvider } from 'react-head';
import configureStore from './configureStore';
import App from './components/App';
import './depict.global.scss';

const hydrate = () => {
	const { store } = configureStore(window.REDUX_STATE);

	ReactDOM.hydrate(
		<Provider store={store}>
			<HeadProvider>
				<App store={store} />
			</HeadProvider>
		</Provider>,
		document.getElementById('root'),
	);
};

export default hydrate;
